import { DateTime } from "luxon";

const weekdays = {
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
  7: "sunday",
};

function wholeDateIsBlackout(blackoutDates, dateTime) {
  if(!blackoutDates) return false;
  for(let i=0; i<blackoutDates.length; i++) {
    const parsed = DateTime.fromISO(blackoutDates[i].Date);
    const sameDate = parsed.year === dateTime.year
      && parsed.ordinal === dateTime.ordinal;
    const blackoutIsWholeDay = !blackoutDates[i].StartTime
      || !blackoutDates[i].EndTime;

    if(sameDate && blackoutIsWholeDay) {
      return true;
    }
  }

  return false;
}

function applyBlackoutToOperatingHours(blackoutDates, operatingHours, dateTime) {
  if(wholeDateIsBlackout(blackoutDates, dateTime)) {
    return null;
  } else if(!blackoutDates) {
    return operatingHours;
  } else {
    for(let i=0; i<blackoutDates.length; i++) {
      const thisOne = blackoutDates[i];
      const blackoutDate = DateTime.fromISO(thisOne.Date);
      if(blackoutDate.year === dateTime.year
        && blackoutDate.ordinal === dateTime.ordinal
      ) {
        const blackoutStart = DateTime.fromFormat(thisOne.StartTime, 'HH:mm');
        const blackoutEnd = DateTime.fromFormat(thisOne.EndTime, 'HH:mm');
        const operationStart = DateTime.fromFormat(
          operatingHours.OpeningTime,
          'HH:mm:ss',
        );
        const operationEnd = DateTime.fromFormat(
          operatingHours.ClosingTime,
          'HH:mm:ss',
        );

        if(blackoutEnd <= operationStart || blackoutStart >= operationEnd) {
          continue;
          // Loop must go on in case of multiple blackouts for same date
        } else if(blackoutStart <= operationStart
          && blackoutEnd >= operationEnd
        ) {
          return null;
        } else if(blackoutStart <= operationStart) {
          return {
            ...operatingHours,
            OpeningTime: blackoutEnd.toFormat('HH:mm:ss'),
          };
        } else if(blackoutEnd < operationEnd) {
          // Blackout splits operating hours into two seperate operating hours
          // Second one is embedded inside single output to be used if array of
          // operating hours can be passed
          return {
            ...operatingHours,
            ClosingTime: blackoutStart.toFormat('HH:mm:ss'),
            secondOperatingHours: {
              ...operatingHours,
              OpeningTime: blackoutEnd.toFormat('HH:mm:ss'),
            }
          };
        } else {
          return {
            ...operatingHours,
            ClosingTime: blackoutStart.toFormat('HH:mm:ss'),
          };
        }
      }
    }

    return operatingHours;
  }
}
export function getMaxDate(zone) {
  const max = DateTime.local(9999, 12, 31);
  if (zone && max.setZone(zone).isValid && max.zoneName !== zone) {
    return max.setZone(zone);
  }
  return max;
}
export function getCurrentDate(zone) {
  let now = DateTime.local();
  if (zone && now.setZone(zone).isValid && now.zoneName !== zone) {
    return now.setZone(zone);
  }
  return now;
}
export function getCustomDate(date,zone) {
  let now = DateTime.fromJSDate(date, {zone: zone});
  if (zone && now.setZone(zone).isValid && now.zoneName !== zone) {
    return now.setZone(zone);
  }
  return now;
}
export function isTimestampAfterCurrentDate(timeStampSecond, currentDateZone) {
  if (!timeStampSecond) return false;
  let now = getCurrentDate(currentDateZone);
  return DateTime.fromJSDate(new Date(timeStampSecond * 1000)) >= now;
}

export function isTimestampAfterDate(time, timeStampSecond, currentDateZone) {
  if (!timeStampSecond || !time) return false;
  return timeStampSecond * 1000 >= time.setZone(currentDateZone).ts;
}

export function isTimestrAfterCurrentDate(timeStr, currentTimeStr) {
  if (!timeStr || !currentTimeStr) {
    return false;
  }
  let result =
    DateTime.fromFormat(timeStr, "HH:mm:ss") >=
    DateTime.fromFormat(currentTimeStr, "HH:mm:ss");
  return result;
}

export function isMenuAvailable(now, menuTimeSetting) {
  const presentWeekday = now.weekday == 7 ? 0 : now.weekday;
  if (menuTimeSetting.DayOfWeek != presentWeekday) {
    return false;
  }
  return (
    !isTimestrAfterCurrentDate(
      menuTimeSetting.StartTime + ":00",
      now.toFormat("HH:mm:ss")
    ) &&
    isTimestrAfterCurrentDate(
      menuTimeSetting.EndTime + ":59",
      now.toFormat("HH:mm:ss")
    )
  );
}

export function operatingHours(blackoutDates, date, operatingHours) {
  if (!date || !operatingHours || operatingHours.length == 0 || !date.isValid) {
    return {
      openTime: null,
      closeTime: null,
    };
  }
  let operatinHour = "";
  operatingHours.forEach((item) => {
    if (item.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()) {
      operatinHour = item;
    }
  });
  if (operatinHour && operatinHour.OpeningTime && operatinHour.ClosingTime) {
    if (
      !DateTime.fromFormat(operatinHour.OpeningTime, "HH:mm:ss").isValid ||
      !DateTime.fromFormat(operatinHour.ClosingTime, "HH:mm:ss").isValid
    ) {
      return {
        openTime: null,
        closeTime: null,
      };
    } else if(wholeDateIsBlackout(blackoutDates, date)) {
      return null;
    }
    operatinHour = applyBlackoutToOperatingHours(blackoutDates, operatinHour, date);
    if(operatinHour === null
      || !DateTime.fromFormat(operatinHour.OpeningTime, "HH:mm:ss").isValid
      || !DateTime.fromFormat(operatinHour.ClosingTime, "HH:mm:ss").isValid
    ) {
      return null;
    }
    var operationTime = {
      openTime: DateTime.fromFormat(
        operatinHour.OpeningTime,
        "HH:mm:ss"
      ).toFormat("hh:mm a"),
      closeTime: DateTime.fromFormat(
        operatinHour.ClosingTime,
        "HH:mm:ss"
      ).toFormat("hh:mm a"),
    };
    return operationTime;
  }
  return null;
}

export function extractTimeSlotInDate(
  blackoutDates,
  deliveryTimeSlots,
  dpDate,
  operatinHours,
) {
  if (
    !deliveryTimeSlots ||
    deliveryTimeSlots.length == 0 ||
    !dpDate ||
    !operatinHours
  ) {
    return null;
  }
  var date = DateTime.fromISO(DateTime.fromJSDate(dpDate).toISODate());
  let allOperatingHours;
  if(operatinHours.secondOperatingHours) {
    const secondOperatingHours = {...operatinHours.secondOperatingHours};
    // delete operatinHours.secondOperatingHours;
    allOperatingHours = [operatinHours, secondOperatingHours];
  } else {
    operatinHours = applyBlackoutToOperatingHours(blackoutDates, operatinHours, date);
    if(operatinHours === null
      || !DateTime.fromFormat(operatinHours.OpeningTime, "HH:mm:ss").isValid
      || !DateTime.fromFormat(operatinHours.ClosingTime, "HH:mm:ss").isValid
    ) {
      return null;
    }
    allOperatingHours = [operatinHours]
  }
  let slots = [];

  allOperatingHours.forEach((operatinHours) => {
    let openingTime = DateTime.fromFormat(operatinHours.OpeningTime, "HH:mm:ss");
    let closingTime = DateTime.fromFormat(operatinHours.ClosingTime, "HH:mm:ss");
    deliveryTimeSlots
      .filter(
        (p) => p.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()
      )
      .sort((a, b) => {
        let aStart = DateTime.fromFormat(a.StartTime, "HH:mm:ss");
        let bStart = DateTime.fromFormat(b.StartTime, "HH:mm:ss");
        return aStart > bStart ? 1 : -1;
      })
      .forEach((item) => {
        let startTime = DateTime.fromFormat(item.StartTime, "HH:mm:ss");
        let endTime = DateTime.fromFormat(item.EndTime, "HH:mm:ss");
        if (endTime > openingTime) {
          slots.push({
            OpeningTime:
              openingTime > startTime
                ? openingTime.toFormat("HH:mm:ss")
                : item.StartTime,
            ClosingTime:
              closingTime < endTime ? operatinHours.ClosingTime : item.EndTime,
            DayOfWeek: item.DayOfWeek,
          });
        }
      });
  });

  return slots;
}

export function initPickupDeliveryTimes(
  blackoutDates,
  operatingHours,
  orderPreparationTime,
  dpDate,
  localDate,
  estimateDeliverTime,
  selectUpperTime = true,
  timeInterval = 15,
  deliveryTimeSlots = null,
  isDeliveryTimeSlotsEnable = false,
  preOrderCutOffTime
) {
  if (
    orderPreparationTime < 0 ||
      (
        (!Array.isArray(operatingHours) || operatingHours.length == 0)
          && (!deliveryTimeSlots || deliveryTimeSlots.length == 0)
      )
  ) {
    return [];
  }
  if (!estimateDeliverTime) {
    estimateDeliverTime = 0;
  } else {
    estimateDeliverTime = parseInt(estimateDeliverTime.toFormat("m"));
  }
  var date = DateTime.fromISO(DateTime.fromJSDate(dpDate).toISODate());
  let operatinHours = [];
  operatingHours.forEach((item) => {
    if (item.DayOfWeek.toLowerCase() == date.toFormat("cccc").toLowerCase()) {
      const blackedOutOperatingHours = applyBlackoutToOperatingHours(
        blackoutDates,
        item,
        date,
      );
      if(blackedOutOperatingHours.secondOperatingHours) {
        const secondOperatingHours = {...blackedOutOperatingHours.secondOperatingHours}
        // delete blackedOutOperatingHours.secondOperatingHours;
        operatinHours.push(blackedOutOperatingHours);
        operatinHours.push(secondOperatingHours);
      } else {
        operatinHours.push(blackedOutOperatingHours);
      }
    }
  });
  if (!operatinHours || operatinHours.length == 0) return [];

  let timeSlots = [];
  operatinHours.forEach((item) => {
    const output = extractTimeSlotInDate(
      blackoutDates,
      deliveryTimeSlots,
      dpDate,
      item,
    );
    if(Array.isArray(output)) {
      timeSlots.push(...output);
    }
  });
  if (isDeliveryTimeSlotsEnable) {
    if (!timeSlots || timeSlots.length == 0) return [];
    operatinHours = timeSlots;
  }
  var times = [];
  operatinHours.forEach((hour) => {
    let startingTime = hour.OpeningTime;
    let closingTime = hour.ClosingTime;
    var closingDateTime = DateTime.fromFormat(
      date.toFormat("dd MMMM yyyy") + " " + closingTime,
      "dd MMMM yyyy hh:mm:ss",
      { zone: localDate.zone }
    );
    var startingDateTime = DateTime.fromFormat(
      date.toFormat("dd MMMM yyyy") + " " + startingTime,
      "dd MMMM yyyy hh:mm:ss",
      { zone: localDate.zone }
    );
    if (timeInterval == 0) timeInterval = 15;
    let sameDay =
      localDate.day == startingDateTime.day &&
      localDate.month == startingDateTime.month;
    if (localDate <= closingDateTime || !sameDay)
      times = [
        ...times,
        ...populateTimes(
          startingDateTime,
          closingDateTime,
          orderPreparationTime,
          localDate,
          estimateDeliverTime,
          selectUpperTime,
          timeInterval,
          times.length == 0,
          preOrderCutOffTime
        ),
      ];
  });
  return times;
}
export function populateTimes(
  startingDateTime,
  closingDateTime,
  orderPreparationTime,
  localDate,
  estimateDeliverTime,
  selectUpperTime,
  timeInterval,
  isEmpty = false,
  preOrderCutOffTime
) {
  let sameDay =
    localDate.day == startingDateTime.day &&
    localDate.month == startingDateTime.month;
  var times = new Array();
  var orderPrepartionTime = orderPreparationTime || 0;
  let waitTime = orderPrepartionTime;
  if (estimateDeliverTime) waitTime = estimateDeliverTime;

  waitTime = waitTime || 2;
  let nextTime = startingDateTime;
  if (sameDay) {
    if (localDate.plus({ minutes: orderPrepartionTime }) >= startingDateTime) {
      nextTime = localDate.plus({ minutes: orderPrepartionTime });
    } else {
      nextTime = startingDateTime;
    }
  } else {
    if (preOrderCutOffTime) {
      nextTime = startingDateTime;
    } else {
      if (localDate.plus({ minutes: waitTime }) >= startingDateTime) {
        nextTime = localDate.plus({ minutes: waitTime });
      } else {
        nextTime = startingDateTime;
      }
    }
  }

  var slotRange = timeInterval;
  if (sameDay && estimateDeliverTime) {
    slotRange = estimateDeliverTime - orderPrepartionTime;
  }
  while (nextTime  < closingDateTime) {
    if (times.length == 0) {
      if (sameDay) {
        if (localDate < startingDateTime) {
          if (nextTime > closingDateTime) break;
        } else if (nextTime > closingDateTime) {
          break;
        }
        if (localDate >= startingDateTime || isEmpty) {
          if (selectUpperTime) {
            times.push({
              format: `ASAP (${nextTime.toFormat("h:mm a")} - ${nextTime
                .plus({ minutes: slotRange })
                .toFormat("h:mm a")})`,
              time: nextTime.plus({ minutes: slotRange }),
            });
          } else {
            times.push({
              format: `ASAP (${nextTime.toFormat("h:mm a")})`,
              time: nextTime,
            });
          }
          nextTime = nextTime.plus({ minutes: timeInterval });
          continue;
        }
      }
    }
    let formattedDate = `${nextTime.toFormat("h:mm a")} - ${nextTime
      .plus({ minutes: slotRange })
      .toFormat("h:mm a")}`.toLowerCase();
    times.push({
      format: formattedDate,
      time: selectUpperTime
        ? nextTime.plus({ minutes: slotRange })
        : nextTime,
    });

    // plus timeInterval minutes
    nextTime = nextTime.plus({ minutes: timeInterval });
  }
  return times;
}

export function availablePickupDeliveryDates(
  blackoutDates,
  orderPreparationTime,
  operatinHours,
  isInOperation,
  date,
  numberOfDaysInAdvance = 0,
  preOrderCutOffDays = 0,
  preOrderCutOffTime = "00:00",
  deliveryTimeSlots,
  isDeliveryTimeSlotsEnable
) {
  var startDate = date.plus({ minutes: orderPreparationTime });
  let cutOffDays = preOrderCutOffDays || 0;
  var nextOpenDay = getNexOpenDate(
    blackoutDates,
    operatinHours,
    date.plus({
      minutes: orderPreparationTime,
    }),
    true,
    deliveryTimeSlots,
    isDeliveryTimeSlotsEnable,
    numberOfDaysInAdvance,
    preOrderCutOffDays,
    preOrderCutOffTime,
  );
  if(cutOffDays > 0)
  {
    nextOpenDay = getNexOpenDate(
      blackoutDates,
      operatinHours,
      date.plus({
        minutes: orderPreparationTime,
        days: cutOffDays
      }),
      true,
      deliveryTimeSlots,
      isDeliveryTimeSlotsEnable,
      numberOfDaysInAdvance,
      preOrderCutOffDays,
      preOrderCutOffTime,
    );
  }
  var cutOffTimeEnable = true;
  let cutOffTime = DateTime.fromFormat(
    date.toFormat("dd MMMM yyyy") + " " + (preOrderCutOffTime || "00:00"),
    "dd MMMM yyyy hh:mm",
    { zone: date.zone }
  );
  if (date > cutOffTime && cutOffDays) {
    cutOffDays++;
  }
  if(nextOpenDay)
  {
    if (nextOpenDay.day != date.day) {
      cutOffTimeEnable = false;
      if (cutOffDays > 0 && preOrderCutOffTime) {
        startDate = getNexOpenDate(
          blackoutDates,
          operatinHours,
          date.plus({
            days: cutOffDays,
          }),
          false,
          deliveryTimeSlots,
          isDeliveryTimeSlotsEnable,
          numberOfDaysInAdvance,
          preOrderCutOffDays,
          preOrderCutOffTime,
        );
      } else {
        startDate = getNexOpenDate(
          blackoutDates,
          operatinHours,
          date.plus({
            minutes: orderPreparationTime,
          }),
          false,
          deliveryTimeSlots,
          isDeliveryTimeSlotsEnable,
          numberOfDaysInAdvance,
          preOrderCutOffDays,
          preOrderCutOffTime,
        );
      }
    } else {
      startDate = getNexOpenDate(
        blackoutDates,
        operatinHours,
        date.plus({
          minutes: orderPreparationTime,
        }),
        true,
        deliveryTimeSlots,
        isDeliveryTimeSlotsEnable,
        numberOfDaysInAdvance,
        preOrderCutOffDays,
        preOrderCutOffTime,
      );
    }
  }
  
  var disableAfter = numberOfDaysInAdvance > 0
    ? getCurrentDate(startDate.zone.zoneName).plus({ days: numberOfDaysInAdvance })
    : getMaxDate(startDate.zone.zoneName);
  var result = createDisableDates(
    blackoutDates,
    startDate ? startDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }):null,
    disableAfter,
    operatinHours,
    isInOperation,
    orderPreparationTime,
    deliveryTimeSlots,
    isDeliveryTimeSlotsEnable,
    cutOffDays,
    preOrderCutOffTime,
    cutOffTimeEnable
  );
  return result;
}

export function createDisableDates(
  blackoutDates,
  startDate,
  twoWeekAfter,
  operatingHours,
  isInOperation,
  orderPreparationTime,
  deliveryTimeSlots,
  isDeliveryTimeSlotsEnable,
  cutOffDays,
  preOrderCutOffTime,
  cutOffTimeEnable
) {
  return {
    customPredictor: function(date) {
      if(!deliveryTimeSlots && isDeliveryTimeSlotsEnable)
        return true;
      date = DateTime.fromJSDate(date, { zone: startDate.zone }).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

      if (
        date < startDate //compare day, month and year
      ) {
        return true;
      }
      if (
        date > twoWeekAfter //compare day, month and year
      ) {
        return true;
      }
      if(wholeDateIsBlackout(blackoutDates, date)) {
        return true;
      }

      if (date.equals(startDate)) {
        var dpDate = new Date(startDate.toISODate());
        var times = initPickupDeliveryTimes(
          blackoutDates,
          operatingHours,
          orderPreparationTime,
          dpDate,
          getCurrentDate(startDate.zone.zoneName),
          0,
          false,
          15,
          deliveryTimeSlots,
          isDeliveryTimeSlotsEnable,
          preOrderCutOffTime
        );
        if (times.length == 0 || !times[0]) {
          return true;
        } else return false;
      }
      if (!IsStoreOpenOnDate(blackoutDates, operatingHours, isInOperation, date)) {
        return true;
      } else {
        if (cutOffTimeEnable) {
          if (
            date <
            startDate.plus({
              days: cutOffDays,
            }) //compare day, month and year
          ) {
            return true;
          }
        }

        dpDate = new Date(date.toISODate());
        times = initPickupDeliveryTimes(
          blackoutDates,
          operatingHours,
          orderPreparationTime,
          dpDate,
          getCurrentDate(startDate.zone.zoneName),
          0,
          false,
          15,
          deliveryTimeSlots,
          isDeliveryTimeSlotsEnable,
          preOrderCutOffTime
        );
        if (times.length == 0 || !times[0]) {
          return true;
        }
      }
    },
  };
}

export function IsStoreOpenOnDate(blackoutDates, operatingHours, isInOperation, date) {
  let todayStr = weekdays[date.weekday];
  let todayeOperatinHours = operatingHours.find(
    (p) => p.DayOfWeek.toLowerCase() == todayStr
  );

  if (!isInOperation) {
    return false;
  }
  if(wholeDateIsBlackout(blackoutDates, date)) {
    return false;
  }

  return applyBlackoutToOperatingHours(blackoutDates, todayeOperatinHours, date);
}

export function IsStoreOpenAtTime(blackoutDates, operatingHours, isInOperation, now) {
  if (!isInOperation) return false;
  if (wholeDateIsBlackout(blackoutDates, now)) return false;
  let operatinHours = IsStoreOpenOnDate(blackoutDates, operatingHours, isInOperation, now);
  if (operatinHours) {
    var result =
      isTimestrAfterCurrentDate(
        now.toFormat("HH:mm:ss"),
        operatinHours.OpeningTime
      ) &&
      isTimestrAfterCurrentDate(
        operatinHours.ClosingTime,
        now.toFormat("HH:mm:ss")
      );
    return result;
  }
  return false;
}

export function getNexOpenDate(
  blackoutDates,
  storeOperatingHours,
  startDate,
  sameDay = false,
  deliveryTimeSlots = null,
  isDeliveryTimeSlotsEnable = false,
  numberOfDaysInAdvance = 0,
  preOrderCutOffDays = 0,
  preOrderCutOffTime = "00:00"
) {
  const currentDateTime = getCurrentDate(startDate.zone.zoneName);
  // Calculate maximum delivery date
  const maxDeliveryDate = numberOfDaysInAdvance > 0
    ? currentDateTime.plus({ days: numberOfDaysInAdvance }).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    : getMaxDate(startDate.zone.zoneName);
  // Calculate minimum delivery date
  let minDeliveryDate = startDate;
  if (preOrderCutOffDays > 0) {
    // Calculate pre-order cut off date time
    const cutOffDateTime = DateTime.fromFormat(
      currentDateTime.toFormat("dd MMMM yyyy") + " " + (preOrderCutOffTime || "00:00"),
      "dd MMMM yyyy hh:mm",
      { zone: currentDateTime.zone });
    // If the cut off time is already passed the current date time, then we need to increase the pre-order cut off
    // days by 1.
    if (cutOffDateTime < currentDateTime) {
      preOrderCutOffDays = preOrderCutOffDays + 1;
    }
    // The min delivery date is now calculated from the current date time plus pre-order cut off days.
    minDeliveryDate = currentDateTime.plus({ days: preOrderCutOffDays }).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  }
  
  // eslint-disable-next-line no-constant-condition
  var index = -1;
  while (index < 7) {
    index++;
    const thisDay = startDate.plus({ days: index });

    // If the current day is pass max delivery date, stops checking next dates
    if (thisDay > maxDeliveryDate) return null;
    // If the current day is pass max delivery date, continues to check next dates
    if (thisDay < minDeliveryDate) continue;

    let todayStr = weekdays[thisDay.weekday];
    let operatinHours = storeOperatingHours.find(
      (p) => p.DayOfWeek.toLowerCase() == todayStr
    );
    operatinHours = applyBlackoutToOperatingHours(blackoutDates, operatinHours, thisDay);
    if (
      !operatinHours ||
      !operatinHours.OpeningTime ||
      !operatinHours.ClosingTime
    )
      continue;
    if (isDeliveryTimeSlotsEnable) {
      var slots = extractTimeSlotInDate(
        blackoutDates,
        deliveryTimeSlots,
        thisDay.toJSDate(),
        operatinHours
      );
      if (slots && slots.length > 0) {
        operatinHours = slots[0];
        operatinHours.ClosingTime = slots[slots.length - 1].ClosingTime;
      } else {
        continue;
      }
    }
    let now = thisDay;
    let closing = DateTime.fromFormat(
      now.toFormat("yyyy/MM/dd") + " " + operatinHours.ClosingTime,
      "yyyy/MM/dd hh:mm:ss",
      { zone: startDate.zone }
    );
    if (index > 0) {
      return DateTime.fromFormat(
        now.toFormat("yyyy/MM/dd") + " " + operatinHours.OpeningTime,
        "yyyy/MM/dd hh:mm:ss",
        { zone: startDate.zone }
      );
    }
    if (now <= closing || !sameDay) {
      return now;
    }
  }
}

export function getDayOfWeekSurcharge(time) {
  let now = time;
  let DayOfWeekLabel;
  switch (now.toFormat("cccc").toLowerCase()) {
    case "monday":
      DayOfWeekLabel = 1;
      break;
    case "tuesday":
      DayOfWeekLabel = 2;
      break;
    case "wednesday":
      DayOfWeekLabel = 3;
      break;
    case "thursday":
      DayOfWeekLabel = 4;
      break;
    case "friday":
      DayOfWeekLabel = 5;
      break;
    case "saturday":
      DayOfWeekLabel = 6;
      break;
    case "sunday":
      DayOfWeekLabel = 0;
      break;
    default:
      DayOfWeekLabel = 7;
      break;
  }
  return DayOfWeekLabel;
}

export function areWeInTimeSetting(timeSetting) {
  const now = DateTime.local();
  const haveSameWeekday = now.weekday === timeSetting.DayOfWeek;

  if(haveSameWeekday) {
    const startDateTime = DateTime.local().set({hour: timeSetting.StartTime.split(':')[0], minute: timeSetting.StartTime.split(':')[1]});
    const endDateTime = DateTime.local().set({hour: timeSetting.EndTime.split(':')[0], minute: timeSetting.EndTime.split(':')[1]});
    const nowIsAfterStart = startDateTime.diffNow().values['milliseconds'] < 0;
    const nowIsBeforeEnd = endDateTime.diffNow().values['milliseconds'] > 0;
    return nowIsAfterStart && nowIsBeforeEnd;
  } else {
    return false;
  }
}